/* HappyPets theme – vanilla JS, inga beroenden */
(function () {
  'use strict';
  var HP = window.HP || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Pengar ---------- */
  function money(cents) {
    var n = Math.round(cents) / 100;
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    var str = (whole ? Math.round(n).toString() : n.toFixed(2)).replace('.', ',');
    var parts = str.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',') + ' kr';
  }
  HP.money = money;

  function tiers() {
    return String(HP.tiers || '').split(',').map(function (t) {
      var a = t.split(':');
      return { q: parseInt(a[0], 10), p: parseFloat(String(a[1] || '').replace(',', '.')) };
    }).filter(function (t) { return t.q > 0 && !isNaN(t.p); }).sort(function (a, b) { return a.q - b.q; });
  }

  /* ---------- Header / meny ---------- */
  $$('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('menu-open', open);
    });
  });
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Meddelandefält (roterar om flera) ---------- */
  $$('[data-announce]').forEach(function (bar) {
    var msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Galleri ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', g);
    var dots = $$('.gallery__dot', g);
    var current = 0;
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) mark(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
  });

  /* ---------- Korta omdömen (roterar) ---------- */
  $$('[data-quotes]').forEach(function (q) {
    var items = $$('.quote', q);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Produktsida: paketväljare + köp ---------- */
  $$('[data-pdp]').forEach(function (pdp) {
    var bundle = $('[data-bundle]', pdp);
    var form = $('[data-product-form]', pdp);
    var qtyInput = form && $('[data-qty-input]', form);
    var atc = form && $('[data-atc]', form);
    var atcPrice = form && $('[data-atc-price]', form);
    var err = form && $('[data-buy-error]', form);
    var stickyLabel = $('[data-sticky-label]', pdp);

    function select(tier) {
      if (!bundle || !tier) return;
      $$('[data-tier]', bundle).forEach(function (t) {
        var on = t === tier;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var packs = parseInt(tier.getAttribute('data-packs'), 10) || 1;
      var price = parseInt(tier.getAttribute('data-price'), 10) || 0;
      if (qtyInput) qtyInput.value = packs;
      if (atcPrice) atcPrice.textContent = money(price);
      if (stickyLabel) stickyLabel.textContent = ($('.tier__label', tier) || {}).textContent + ' · ' + money(price);
    }
    if (bundle) {
      bundle.addEventListener('click', function (e) {
        var t = e.target.closest('[data-tier]');
        if (t) select(t);
      });
      bundle.addEventListener('keydown', function (e) {
        if (['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(e.key) < 0) return;
        var list = $$('[data-tier]', bundle);
        var i = list.indexOf($('.is-selected', bundle));
        var n = (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length;
        select(list[n]); list[n].focus(); e.preventDefault();
      });
      select($('.is-selected', bundle) || $('[data-tier]', bundle));
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atc || atc.disabled) return;
        atc.classList.add('is-loading'); atc.disabled = true;
        if (err) err.hidden = true;
        var id = parseInt(form.querySelector('[name="id"]').value, 10);
        var q = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        fetch(HP.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: q }] })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Något gick fel'); return j; });
        }).then(function () {
          if (window.HPCart) window.HPCart.open(); else window.location.href = HP.routes.cart;
        }).catch(function (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        }).finally(function () {
          atc.classList.remove('is-loading'); atc.disabled = false;
        });
      });
    }

    /* fast köpknapp (mobil) */
    var bar = $('[data-sticky-buy]', pdp);
    if (bar && atc && 'IntersectionObserver' in window) {
      var visible = true;
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }).observe(atc);
      $('[data-sticky-btn]', bar).addEventListener('click', function () {
        (bundle || atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });

  /* ======================================================
     Varukorg – delad för drawer och varukorgssida
     ====================================================== */
  var drawer = $('[data-cart-drawer]');
  var uis = $$('[data-cart-ui]');
  if (!uis.length) return;

  var state = { cart: null };
  var queue = Promise.resolve();
  var timers = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function getCart() { return fetch(HP.routes.cart + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', !n); });
  }
  function packId(ui) { return parseInt(ui.getAttribute('data-pack-product'), 10) || 0; }
  function isPack(ui, item) {
    var pid = packId(ui);
    return pid ? item.product_id === pid : false;
  }

  function lineHTML(ui, it) {
    var pack = isPack(ui, it);
    var size = HP.packSize || 12;
    var cmp = pack && HP.packCompare ? HP.packCompare * it.quantity : it.original_line_price;
    var strike = cmp > it.final_line_price;
    var variant = pack ? (it.quantity * size) + ' st ' + (HP.unitLabel || '') : (it.variant_title || '');
    var mid = pack ? (it.quantity * size) + ' st' : it.quantity;
    return '<div class="line" data-key="' + esc(it.key) + '">' +
      '<a class="line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
      '<div class="line__info">' +
        '<a class="line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<p class="line__variant">' + esc(variant) + '</p>' : '') +
        '<div class="stepper">' +
          '<button type="button" data-cu-step="-1" aria-label="Minska">−</button>' +
          '<span class="stepper__val" data-cu-val>' + esc(mid) + '</span>' +
          '<button type="button" data-cu-step="1" aria-label="Öka">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="line__price">' +
        (strike ? '<s>' + money(cmp) + '</s>' : '') +
        '<strong>' + money(it.final_line_price) + '</strong>' +
        '<button type="button" class="line__remove" data-cu-remove>Ta bort</button>' +
      '</div>' +
    '</div>';
  }

  function renderOffer(ui, cart) {
    var offer = $('[data-cu-offer]', ui);
    if (!offer) return;
    var pid = packId(ui);
    var packs = cart.items.reduce(function (s, i) { return s + (pid && i.product_id === pid ? i.quantity : 0); }, 0);
    var list = tiers();
    if (!packs || !list.length) { offer.hidden = true; return; }
    offer.hidden = false;
    var size = HP.packSize || 12;
    var next = list.filter(function (t) { return t.q > packs; })[0];
    var txt = $('[data-cu-offer-text]', offer);
    if (next) {
      var more = (next.q - packs) * size;
      var saveNext = HP.packCompare ? (HP.packCompare * next.q) / 100 - next.p : 0;
      txt.innerHTML = 'Lägg till <strong>' + more + ' st</strong> till och få <strong>' + (next.q * size) + ' st för ' + money(next.p * 100) + '</strong>' +
        (saveNext > 0 ? ' <span class="chip">Spara ' + money(saveNext * 100) + '</span>' : '');
      offer.classList.remove('is-done');
    } else {
      txt.innerHTML = 'Du har <strong>bästa priset</strong> – maximal rabatt aktiverad';
      offer.classList.add('is-done');
    }
    var steps = $('[data-cu-steps]', offer);
    var maxQ = list[list.length - 1].q, minQ = list[0].q;
    var pct = Math.max(0, Math.min(100, (Math.min(packs, maxQ) - minQ) / Math.max(1, maxQ - minQ) * 100));
    steps.style.setProperty('--fill', (pct / 100).toFixed(3));
    steps.style.setProperty('--edge', (50 / list.length) + '%');
    steps.innerHTML = list.map(function (t) {
      var cls = packs >= t.q ? ' is-hit' : '';
      if (packs === t.q || (packs > maxQ && t.q === maxQ)) cls += ' is-current';
      return '<li class="steps__item' + cls + '"><span class="steps__dot">' + (packs >= t.q ? '✓' : '') + '</span><span class="steps__q">' + (t.q * size) + ' st</span><span class="steps__p">' + money(t.p * 100) + '</span></li>';
    }).join('');
  }

  function renderUI(ui, cart) {
    var body = $('[data-cu-body]', ui);
    var foot = $('[data-cu-foot]', ui);
    body.classList.remove('is-busy');
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><span class="cart-empty__icon"><svg viewBox="0 0 24 24" width="36" height="36" fill="currentColor" aria-hidden="true"><ellipse cx="6.2" cy="10" rx="2" ry="2.6"/><ellipse cx="10" cy="6.4" rx="2" ry="2.7"/><ellipse cx="14.3" cy="6.4" rx="2" ry="2.7"/><ellipse cx="18" cy="10" rx="2" ry="2.6"/><path d="M12.1 11.6c-2.6 0-5.3 3.4-5.3 5.7 0 2 1.7 2.7 3 2.4 1.1-.3 1.6-.8 2.3-.8s1.2.5 2.3.8c1.3.3 3-.4 3-2.4 0-2.3-2.7-5.7-5.3-5.7z"/></svg></span><p>Din varukorg är tom.</p><a class="btn" href="' + (ui.closest('.cart-page') ? '/' : '#') + '" ' + (ui.closest('.cart-page') ? '' : 'data-cart-close') + '>Fortsätt handla</a></div>';
      foot.hidden = true;
      var of = $('[data-cu-offer]', ui); if (of) of.hidden = true;
      return;
    }
    foot.hidden = false;
    var compareTotal = 0;
    body.innerHTML = cart.items.map(function (it) {
      var pack = isPack(ui, it);
      compareTotal += pack && HP.packCompare ? HP.packCompare * it.quantity : it.original_line_price;
      return lineHTML(ui, it);
    }).join('');
    var saved = Math.max(0, compareTotal - cart.total_price);
    var sr = $('[data-cu-save-row]', ui);
    sr.hidden = saved <= 0;
    $('[data-cu-save]', ui).textContent = '−' + money(saved);
    $('[data-cu-total]', ui).textContent = money(cart.total_price);
    renderOffer(ui, cart);
  }

  function renderAll(cart) {
    state.cart = cart;
    setCount(cart.item_count);
    if (drawer) {
      var c = $('[data-cd-count]', drawer);
      if (c) c.textContent = cart.item_count ? cart.item_count : '';
    }
    uis.forEach(function (ui) { renderUI(ui, cart); });
  }

  function refresh() { return getCart().then(renderAll).catch(function () {}); }

  function busy(on) { uis.forEach(function (ui) { ui.classList.toggle('is-busy', on); }); }

  function change(key, qty) {
    queue = queue.then(function () {
      busy(true);
      return fetch(HP.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) renderAll(cart); else return refresh(); })
        .catch(refresh)
        .finally(function () { busy(false); });
    });
    return queue;
  }

  document.addEventListener('click', function (e) {
    var ui = e.target.closest('[data-cart-ui]');
    if (ui) {
      var line = e.target.closest('.line');
      var step = e.target.closest('[data-cu-step]');
      var rm = e.target.closest('[data-cu-remove]');
      if (line && (step || rm)) {
        e.preventDefault();
        var key = line.getAttribute('data-key');
        var item = state.cart && state.cart.items.filter(function (i) { return i.key === key; })[0];
        if (!item) return;
        if (rm) { clearTimeout(timers[key]); line.classList.add('is-removing'); change(key, 0); return; }
        var pending = parseInt(line.getAttribute('data-pending') || item.quantity, 10);
        pending = Math.max(0, pending + parseInt(step.getAttribute('data-cu-step'), 10));
        line.setAttribute('data-pending', pending);
        var val = $('[data-cu-val]', line);
        if (val) val.textContent = isPack(ui, item) ? (pending * (HP.packSize || 12)) + ' st' : pending;
        line.classList.add('is-pending');
        clearTimeout(timers[key]);
        timers[key] = setTimeout(function () { change(key, pending); }, 380);
        return;
      }
    }
    var link = e.target.closest('[data-cart-link]');
    if (link && drawer) { e.preventDefault(); window.HPCart.open(); return; }
    if (e.target.closest('[data-cart-close]') && drawer) { e.preventDefault(); show(false); }
  });

  /* drawer öppna/stäng */
  var lastFocus = null;
  function show(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('no-scroll', on);
    if (on) { lastFocus = document.activeElement; setTimeout(function () { $('.cd__panel', drawer).focus(); }, 60); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) show(false); });

  window.HPCart = {
    open: function () { show(true); uis.forEach(function (ui) { $('[data-cu-body]', ui).classList.add('is-busy'); }); return refresh(); },
    refresh: refresh
  };

  if ($('.cart-page [data-cart-ui]')) refresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
